export function resolveApiAssetUrl(path?: string, apiBaseUrl = '') {
  const value = path?.trim()
  if (!value) return ''
  if (/^(?:https?:|data:|blob:)/i.test(value)) return value

  const normalizedPath = `/${value.replace(/\\/g, '/').replace(/^\/+/, '')}`
  const normalizedBase = apiBaseUrl.replace(/\/$/, '')
  return normalizedBase ? `${normalizedBase}${normalizedPath}` : normalizedPath
}

export function resolveApiIVUSUrl(path?: string, apiBaseUrl = '', download = false) {
  const value = path?.trim()
  if (!value) return ''
  if (/^(?:https?:|data:|blob:)/i.test(value)) return value

  const normalizedPath = `/${value.replace(/\\/g, '/').replace(/^\/+/, '')}`
  const normalizedBase = apiBaseUrl.replace(/\/$/, '') + '/dicomStorage/file?path='
  const downloadParam =  download ? '&download=true' : ''
  return normalizedBase ? `${normalizedBase}${normalizedPath}${downloadParam}` : normalizedPath
}